import FileCopier from './FileCopier';

export default FileCopier;
